import React, { useState } from 'react';
import { Box, Button, CardContent, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { Icon } from 'react-icons-kit';
import { chevronLeft } from 'react-icons-kit/fa/chevronLeft';
import { chevronRight } from 'react-icons-kit/fa/chevronRight';

const CarouselContainer = styled(Box)`
  width: 90%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  
`;

const Container = styled(Box)`
  width: 100%;
  position: relative;
`;

const CarouselTrack = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  transition: transform 0.5s ease-in-out;
  transform: ${props => props.transform};
`;

const CarouselCard = styled(Box)`
  flex: 0 0 100%;
`;

const CarouselButton = styled(Box)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s;
  z-index: 1;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    top: 98%;
    &.prev {
      left: 0;
    }

    &.next {
      right: 0;
    }
  }
`;



const Carousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : items.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prevIndex => (prevIndex < items.length - 1 ? prevIndex + 1 : 0));
  };

  return (
    <Container>
        <CarouselContainer>
        <CarouselTrack transform={`translateX(-${currentIndex * 100}%)`}>
            {items.map((item, index) => (
            <CarouselCard key={index}>
                {item}
            </CarouselCard>
            ))}
        </CarouselTrack>
    
        </CarouselContainer>
        <CarouselButton
            onClick={handlePrev}
            sx={{ left: 0 }}
        >
            <Icon icon={chevronLeft} />
        </CarouselButton>
        <CarouselButton
            onClick={handleNext}
            sx={{ right: 0 }}
        >
            <Icon icon={chevronRight} />
        </CarouselButton>
    </Container>

  );
};

export default Carousel;

